import { useResponsive } from '@hooks';
import { Platform, StyleSheet, useWindowDimensions } from 'react-native'
export default function useKanbanStyle(){
    const { width } = useWindowDimensions();
    const isWeb = Platform.OS === 'web';
    const isTablet = width > 768;
    const isResponsive = useResponsive();
    const styles = StyleSheet.create({
        subContainer: {
            flex: 1,
        },
        mainHeaderContainer: {
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
        },
        innerContainer: {
            flexDirection: isResponsive ? 'column' : 'row' ,
        },
        mainContainer: {
            flexDirection: 'column',
            flex:1
        },
        columnContainer: {
            backgroundColor: 'white',
            borderRadius: 12,
            marginBottom: 16,
            elevation: 2,
            borderWidth: 1,
            ...(isWeb && isTablet ? { flex: 1 } : {}),
            margin: 4,
            borderColor: '#e0e0e0',
            ...Platform.select({
                ios: {
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 4,
                },
                web: {
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                },
            }),
        },
        columnHeader: {
            flexDirection: 'row',
            alignItems: 'center',
            padding: 16,
            borderBottomWidth: 1,
            borderBottomColor: '#f3f4f6',
        },
        columnTitle: {
            fontSize: 18,
            fontWeight: '600',
            color: '#374151',
            marginLeft: 12,
            flex: 1,
        },
        columnSubtitle: {
            fontSize: 14,
            fontWeight: '600',
            color: '#4b5563',
            marginLeft: 12,
            marginBottom: 8,
        },
        columnContent: {
            padding: 16,
            gap: 15,
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
        },
        emptyText: {
            fontSize: 14,
            color: '#9ca3af',
            textAlign: 'center',
            fontStyle: 'italic',
            paddingVertical: 20,
        },
        elementItem: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingVertical: 6,
            paddingHorizontal: 16,
            backgroundColor: '#f9fafb',
            marginBottom: 8,
        },
        // Styles pour le filtre
        filterContainer: {
            marginBottom: 8,
            paddingHorizontal: 16,

        },
        filterLabel: {
            fontSize: 16,
            fontWeight: '600',
            color: '#374151',
            marginBottom: 12,
            marginRight: 8,
        },
        filterChipsContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            marginHorizontal: -4, // Compense les marges des chips
        },
        filterScrollView: {
            flexGrow: 0,
        },
        filterChip: {
            paddingHorizontal: 12,
            paddingVertical: 6,
            backgroundColor: '#f3f4f6',
            borderRadius: 20,
            marginHorizontal: 4,
            marginBottom: 6,
            borderWidth: 1,
            borderColor: '#e5e7eb',
        },
        filterChipSelected: {
            backgroundColor: '#3b82f6',
            borderColor: '#3b82f6',
        },
        filterChipText: {
            fontSize: 13,
            color: '#374151',
            fontWeight: '500',
        },
        filterChipTextSelected: {
            color: 'white',
        },
    })
    return {styles};
}

